/**
 * Injects a robots "noindex, nofollow" meta tag when the current hostname
 * does not match any production domain defined in the DOMAINS enum.
 *
 * Relies on the DOMAINS enum from constants/domains as the single source
 * of truth — any new production app added there is automatically protected.
 */
export function applyNoIndexForNonProductionDomains(hostname: string, domains: Record<string, string>): void {
  const productionDomains = Object.values(domains);
  const isProduction = productionDomains.some((domain) => hostname === domain || hostname === `www.${domain}`);

  if (!isProduction) {
    const meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex, nofollow";
    document.head.appendChild(meta);
  }
}
